<template>
	<div>
		<div class="qualified">
			<div class="center fz18 marb18">
				{{doctorbreadcrumbList[1]}}历次质控结果
			</div>
			<el-row :gutter="30" v-loading="loading">
				<el-col v-if="doctorbreadcrumbList[2] == 'personal'">
					<el-table class="qcTable doctor" ref="multipleTable" :data="qCTaskList.Tasks" highlight-current-row>
						<el-table-column prop="TaskId" label="报告编号" key="1"></el-table-column>
						<el-table-column prop="TypeName" label="抽样方式" key="2">
							<template slot-scope="scope">
								<span v-if="scope.row.TypeName == 1">按比例</span>
								<span v-if="scope.row.TypeName == 2">按固定值</span> 
							</template>
						</el-table-column>
						<el-table-column prop="TypeName" label="抽样数量" key="5">
							<template slot-scope="scope">
								{{scope.row.TypeValue}}
								<span v-if="scope.row.TypeName == 1">%</span>
								<span v-if="scope.row.TypeName == 2">例</span>
							</template>
						</el-table-column>
						<el-table-column prop="AverageScore" label="分数" key="3"></el-table-column>
						<el-table-column prop="CreateDt" label="抽样时间" key="4"></el-table-column>
						<el-table-column prop="" label="操作" fixed="right" width="180" key="5">
							<template slot-scope="scope">
								<span class="tableOpe" @click="handleClick(scope.row,'personal')">报告列表</span>
							</template>
						</el-table-column>
					</el-table>
				</el-col>
				<el-col v-else>
					<el-table class="qcTable doctor" ref="multipleTable" :data="qCTaskList.Tasks" highlight-current-row>
						<el-table-column prop="TaskId" label="任务编号" key="6"></el-table-column>
						<el-table-column prop="" label="医生数量" key="7">
							<template slot-scope="scope">
								<span>{{scope.row.FirstApproverCount}}名</span>
							</template>
						</el-table-column>
						<el-table-column prop="TechnicianCount" label="技师数量" key="8">
							<template slot-scope="scope">
								<span>{{scope.row.TechnicianCount}}名</span>
							</template>
						</el-table-column>
						<el-table-column min-width="120" label="抽样方式(每位医生)" key="9">
							<template slot-scope="scope">
								<span v-if="scope.row.TypeName == 1">按比例</span>
								<span v-if="scope.row.TypeName == 2">按固定值</span>
								<span>{{scope.row.TypeValue}}</span>
								<span v-if="scope.row.TypeName == 1">%</span>
								<span v-else>例</span>
							</template>
						</el-table-column>
						<el-table-column prop="Total" label="报告总数" key="10"></el-table-column>
						<el-table-column prop="SampledNum" label="抽样数量" key="11"></el-table-column>
						<el-table-column prop="ReportAverageScore" label="报告平均分" key="12"></el-table-column>
						<el-table-column prop="ImageAverageScore" label="影像平均分" key="13"></el-table-column>
						<el-table-column prop="" label="操作" fixed="right" width="180" key="14">
							<template slot-scope="scope">
								<span class="tableOpe marr15" @click="handleClick(scope.row,'task')">报告列表</span>
								<el-dropdown>
									<span class="el-dropdown-link textColorBlue">
										查看结果<i class="el-icon-arrow-down textColorBlue"></i>
									</span>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item command="a"><span @click="resultClick('技师',scope.row)">技师结果</span></el-dropdown-item>
										<el-dropdown-item command="b"><span @click="resultClick('医生',scope.row)">医生结果</span> </el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
							</template>
						</el-table-column>
					</el-table>
					<div class="collapseBox" v-if="collapseflag.flag">
						<div class="collapseBox-title">
							{{collapseName.hospital}}{{collapseName.name}} (<span>{{doctorsResultList.length}}</span>人) <i class="el-icon-close" @click="closeRbox"></i>
						</div>
						<el-table class="qcTable distributionList" :data="doctorsResultList">
							<el-table-column prop="DoctorName" label="抽样医生" v-if="collapseName.name=='医生'"></el-table-column>
							<el-table-column prop="DoctorName" label="抽样技师" v-else></el-table-column>
							<el-table-column prop="Total" v-if="collapseName.name=='医生'" label="报告总数"></el-table-column>
					
							<el-table-column prop="SampledNum" label="抽样数量"></el-table-column>
							<el-table-column prop="Progress" label="完成进度">
								<template slot-scope="scope">
									<el-tooltip effect="dark" placement="top-start">
										<div class="progress">
											<div class="progress-bar progress-bar-success" :style="`width: ${Math.floor((scope.row.Progress.split('/')[0]/scope.row.Progress.split('/')[1])*100)}%`">
											</div>
											<span class="sr-only">{{(Math.floor((scope.row.Progress.split('/')[0]/scope.row.Progress.split('/')[1])*100))}}%</span>
										</div>
										<div slot="content" class="tableTooltip">
											<div>
												<em></em>
												<span>已完成数量:{{scope.row.Progress.split('/')[0]}}</span>
											</div>
										</div>
									</el-tooltip>
								</template>
							</el-table-column>
							<el-table-column prop="ReportAverageScore" label="报告平均分" v-if="collapseName.name=='医生'"></el-table-column>
							<el-table-column prop="ImageAverageScore" label="影像平均分" v-else></el-table-column>
							<el-table-column prop="" label="操作" width="240">
								<template slot-scope="scope">
									<span class="tableOpe" @click="distributionClick(scope.row)">查看报告</span>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</el-col>
			</el-row>
			<div class="pages">
				<el-pagination class="pageAll" layout="prev, pager, next" :total="qCTaskList.TotalCount" :page-size='doctorQCTaskParameter.pageCount' :current-page='doctorQCTaskParameter.pageIndex' @current-change='currentChange'>
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import Api from '../../api'
	import axios from '@/js/api'
	import { mapState, mapActions, mapMutations } from 'vuex'
	export default {
		data() {
			return {
				collapseName: {
					name: '',
					hospital: '',
					
				},
				unSelectedDoctorsList: [],
			};
		},
		computed: {
			...Vuex.mapState('breadcrumb',['loading','collapseflag']),
			...Vuex.mapState('managerPlanList', ['doctorsResultList','getExpertReportListParameter', 'reviewName']),
			...Vuex.mapState('visualization',['qCTaskList','doctorQCTaskParameter','doctorbreadcrumbList','visbreadcrumbList']),
			...Vuex.mapState('supervisor', ['QualifiedPart','GetReportListArr','breadcrumbList']),
		},
		methods: {
			...Vuex.mapMutations('breadcrumb', ['setTootipType', 'clearRow']),
			...Vuex.mapMutations('managerPlanList', ['setLoading', 'currentChangesSecond', 'clearparameter']),
			...Vuex.mapMutations('supervisor',['setBreadcrumbList']),
			...Vuex.mapActions('visualization', ['GetDoctorQCTask','GetHospitalQCTask']),
			...Vuex.mapActions('managerPlanList', ['GetDoctorsResult', 'GetExpertReportList']),
			currentChange(val) {
				this.doctorQCTaskParameter.pageIndex = val;
				if(this.doctorbreadcrumbList[2] == 'personal'){
					this.GetDoctorQCTask();
				}else{
					this.GetHospitalQCTask();
				}
				document.body.scrollTop = document.documentElement.scrollTop = 0;
			},
			handleClick(row){
				this.setTootipType(false);
				this.clearRow();
				this.$store.commit('supervisor/setLoading', true);
				this.$store.commit('supervisor/settableLoading', true); 
				this.$store.commit('supervisor/currentChangesSecond', 1); 
				this.QualifiedPart.hospitalGuid = row.HospitalGuid;
				this.QualifiedPart.doctorName = row.DoctorName;
				this.QualifiedPart.type = row.TaskId;;
				this.setBreadcrumbList();
				this.GetReportListArr.tabType = this.visbreadcrumbList[2];
				this.GetReportListArr.type = row.TaskId;
				this.GetReportListArr.name = '';
				this.GetReportListArr.samplingTaskGuid = row.SamplingTaskGuid;
				this.breadcrumbList.push(this.doctorbreadcrumbList[0]);
				this.breadcrumbList.push(row.DoctorName);
				this.breadcrumbList.push("task");
				this.$router.push("/home/supervisor/qualifiedTable");
				
			},
			resultClick(val, row) {
				this.collapseflag.flag = true;
				this.collapseName.name = val;
				this.collapseName.hospital = row.HospitalName;
				this.getExpertReportListParameter.HospitalGuid = row.HospitalGuid;
				this.getExpertReportListParameter.SamplingTaskGuid = row.SamplingTaskGuid;
				this.getExpertReportListParameter.DoctorType = val == '医生' ? 2 : 3;
				//2审核医生3技师
				this.GetDoctorsResult({
					SamplingTaskGuid: row.SamplingTaskGuid,
					HospitalUid: row.HospitalGuid,
					DoctorType: val == '医生' ? 2 : 3
				});
			},
			closeRbox() {
				this.collapseflag.flag = false;
			},
			distributionClick(row) {
				this.setLoading(true);
				this.currentChangesSecond(1);
				this.setTootipType(false);
				this.reviewName.exports = false;
				//先清空再赋值
				this.clearparameter();
				let name = '';
				name = row.DoctorName;
				this.getExpertReportListParameter.HospitalGuid = row.HospitalGuid;
				this.getExpertReportListParameter.DoctorName = row.DoctorName;
				this.reviewName.name = name;
				this.GetExpertReportList();
				this.$router.push('/home/manager/task/reviewReportList');
			},
		}

	}
</script>